import bemBlock from "@gik/core/utils/bemBlock";
import { Heading } from "@gik/ui-legacy/Heading";
import type React from "react";

interface ISidebarSectionProps
	extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
	title?: React.ReactNode;
	append?: React.ReactNode;
}

export function SidebarSection(
	props: ISidebarSectionProps,
): React.ReactElement {
	const { className, children, title, append, ...otherProps } =
		props as ISidebarSectionProps;

	const bem = bemBlock("sidebar-section");

	return (
		<section className={bem(null, null, className)} {...otherProps}>
			{(title || append) && (
				<header className={bem("title-wrapper")}>
					{title && (
						<Heading level={2} className={bem("title")}>
							{title}
						</Heading>
					)}
					{append}
				</header>
			)}
			{children}
		</section>
	);
}
